var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _vm.loading
        ? [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
          ]
        : [
            _c(
              "div",
              { staticClass: "left_task_part" },
              [
                _c("p", [
                  _vm._v("Задача: "),
                  _c("strong", [_vm._v(_vm._s(_vm.task.id))]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.printDate(_vm.task.created_at))),
                ]),
                _vm._v(" "),
                (_vm.task.users ?? []).length
                  ? _c(
                      "v-popover",
                      {
                        staticClass: "d-inline",
                        attrs: { placement: "bottom", "auto-hide": true },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "badge badge-info pointer" },
                          [_vm._v("Пользователи")]
                        ),
                        _vm._v(" "),
                        _c("template", { slot: "popover" }, [
                          _c(
                            "div",
                            _vm._l(_vm.task.users, function (u) {
                              return _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n              (" +
                                      _vm._s(u.user_id) +
                                      ")\n              "
                                  ),
                                  _c("UserName", { attrs: { id: u.user_id } }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.order_id && ![19].includes(_vm.task.type_id)
                  ? [
                      _c(
                        "p",
                        { staticClass: "flex align-items-centers" },
                        [
                          _vm._v("Заявка: "),
                          _c("strong", [_vm._v(_vm._s(_vm.task.order_id))]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-info ml-1 mr-1",
                              on: {
                                click: function ($event) {
                                  return _vm.orderToEdit(_vm.task.order_id)
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                          ),
                          _vm._v(" "),
                          _vm.allowToEditPrePaid
                            ? _c("PrePaidButton", {
                                attrs: { order: { id: _vm.task.order_id } },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.task.order.order_phones, function (p) {
                        return _c("div", { staticClass: "mb-2" }, [
                          _c(
                            "a",
                            { attrs: { href: `tel:+${p.phone.phone}` } },
                            [_vm._v(_vm._s(p.phone.phone))]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.mixinGetCityNameByOrder(_vm.task.order))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.task.order.project_label)),
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.printOrderStatus(_vm.task.order)
                            ),
                          },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.type_id === 3
                  ? [
                      _c("p", [
                        _vm._v("Ставка: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.orderSalaryRates[_vm.task.task_data.old_value]
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Запрос: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.orderSalaryRates[_vm.task.task_data.new_value]
                            )
                          ),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                [3, 4, 6, 26, 33].includes(_vm.task.type_id) ||
                _vm.task.created_by === _vm.$currentUID ||
                _vm.allowToCloseByDate(_vm.task.created_at)
                  ? _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Закрыть задачу",
                            loading: _vm.btnLoading,
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.closeTask(_vm.task, true),
                            className: "btn btn-outline-success",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-grow-1" },
              [
                _vm.task.dialog
                  ? [
                      _c("Messages", {
                        attrs: {
                          hideNames: _vm.hideNames,
                          acceptTask: () => _vm.acceptTask(_vm.task.id),
                          dialogId: _vm.task.dialog.id,
                          dialogAccepted:
                            _vm.task.created_by === _vm.$currentUID ||
                            _vm.task.dialog.is_accepted,
                          messages: _vm.task.dialog.messages,
                          updateDialog: (u) =>
                            (_vm.task.dialog = { ..._vm.task.dialog, ...u }),
                        },
                      }),
                    ]
                  : [
                      _vm.task.type_id === 33
                        ? [
                            _c("h4", [
                              _vm._v("Запрос клиента на обратный звонок"),
                            ]),
                            _vm._v(" "),
                            _vm.task.task_data?.task_data
                              ? _c("p", [
                                  _vm._v(_vm._s(_vm.task.task_data.task_data)),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === 24
                        ? [
                            _c("AddSupplierCodes", {
                              attrs: {
                                task: _vm.task,
                                updateTasks: () => _vm.getAllTasks(true),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === 31
                        ? [
                            _c("DisabledDrugsList", {
                              attrs: { drugs: _vm.task.task_data?.drugs },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === 22
                        ? [
                            _c("ManufacturerDrugInfoTask", {
                              attrs: {
                                task: _vm.task,
                                updateTasks: () => _vm.getAllTasks(true),
                                updateTasksPull: () => _vm.getAllTasks(true),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      [23, 26].includes(_vm.task.type_id)
                        ? [
                            _c("SimpleTaskWithComment", {
                              attrs: {
                                showTaskInfo: true,
                                task: _vm.task,
                                updateTasks: () => _vm.getAllTasks(true),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === _vm.groups?.sendOrderByPost?.type
                        ? [_vm._v("\n          send post\n        ")]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === _vm.groups?.diffPrices?.type
                        ? [
                            _c("DiffPriceNoCashPrice", {
                              attrs: { order: _vm.task.order },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Закрыть задачу",
                                    loading: _vm.btnLoading,
                                    color: _vm.$constants.SUCCESS_COLOR,
                                    onClick: () => _vm.closeTask(_vm.task),
                                    className: "btn btn-outline-success",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === _vm.groups?.orderByCashWSms?.type
                        ? [
                            _c("CashOrderWithSMS", {
                              attrs: { order: _vm.task.order },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Закрыть задачу",
                                    loading: _vm.btnLoading,
                                    color: _vm.$constants.SUCCESS_COLOR,
                                    onClick: () => _vm.closeTask(_vm.task),
                                    className: "btn btn-outline-success",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === 27
                        ? [
                            _c("PairDrug", {
                              ref: "pairDrug",
                              attrs: {
                                drug: _vm.task.related_ms_drug,
                                pairedDrugs:
                                  _vm.task.related_ms_drug.related_drugs,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.task.type_id === 14
                        ? [
                            _c("DrugInInvoice", {
                              attrs: {
                                drug: _vm.task.drug,
                                invoice: { id: _vm.task.object_id },
                                taskData: _vm.task.task_data,
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }